import MapperNoteView from "@/features/home/VenuePreview/MapperNoteView";
import EmptyMapperNotes from "@/assets/images/empty-mappernotes.svg";

type MapperViewProps = {
  mapperNotes: any[];
  onRefresh: () => void;
};

const MapperView = ({ mapperNotes, onRefresh }: MapperViewProps) => {
  if (mapperNotes.length === 0) {
    return (
      <div className="flex-1 m-auto w-full">      
        <p className="text-center paragraph-medium-semi-bold  my-10" tabIndex={0}>
          No notes for this venue yet
        </p>
        <img
          src={EmptyMapperNotes}
          alt="No search results"
          className="max-w-[70%] mx-auto my-10"
          aria-hidden="true"
        />
      </div>
    );
  }

  return (
    <div className="mt-2 grid md:grid-cols-2 grid-cols-1 gap-4">
      {mapperNotes.map((note, index) => (
        <MapperNoteView key={index} note={note} onRefresh={onRefresh} />
      ))}
    </div>
  );
};

export default MapperView; 